import * as React from 'react';
import { FlexRow } from '../FlexRow/FlexRow';
import { Button } from '../Button/Button';
import { Header3Text } from '../Typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';

export interface IModalWindowTitleProps {
  mode?: modalWindowMode;
  title?: string | React.ReactNode;
  onClose?: (e: React.MouseEvent<any>) => void;
}

export type modalWindowMode = 'default' | 'transition';

export const ModalWindowTitle: React.FC<IModalWindowTitleProps> = (props) => {
  const shouldDisplayTitle = !props.title || typeof props.title === 'string';

  return (
    <FlexRow justifyContent={'space-between'}>
      {shouldDisplayTitle ? <Header3Text>{props.title}</Header3Text> : props.title}
      {props.mode === 'default' ? (
        <Button type="button" intent={'ghost'} onClick={props.onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </Button>
      ) : null}
    </FlexRow>
  );
};
